import { AlertMessageType } from './alert-message-type';

export class AlertMessage {
  message: string;
  params?: string[];
  dismissible?: boolean;
  type: AlertMessageType;
  translateParams?: boolean;


  constructor(message: string, params?: string[], dismissible = true, type?: AlertMessageType, translateParams = false) {
    this.message = message;
    this.params = params;
    this.dismissible = dismissible;
    this.type = type;
    this.translateParams = translateParams;
  }
}
